import { render, staticRenderFns } from "./Barometer.vue?vue&type=template&id=2c503afa&scoped=true"
import script from "./Barometer.vue?vue&type=script&lang=js"
export * from "./Barometer.vue?vue&type=script&lang=js"
import style0 from "./Barometer.vue?vue&type=style&index=0&id=2c503afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c503afa",
  null
  
)

export default component.exports